import React, { FC, ReactNode } from 'react';
import { Button, Drawer as MaterialDrawer, useTheme } from '@mui/material';

import { CloseIcon } from 'src/shared/components/icons';
import './Drawer.styles.scss';

interface Props {
  open: boolean;
  title: string;
  onClose: () => void;
  children: ReactNode;
  width?: string | number;
  description?: ReactNode;
  headerElement?: ReactNode;
  overflow?: boolean;
}

export const Drawer: FC<Props> = ({
  open,
  onClose,
  children,
  title,
  width,
  headerElement,
  description,
  overflow = true,
}) => {
  const theme = useTheme();

  return (
    <MaterialDrawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { width } }}
      classes={{ paperAnchorRight: `drawer-container ps-4 py-3 ${theme.palette.mode}` }}
    >
      <div className="drawer-header d-flex justify-content-between my-4">
        <div className="me-4">
          {!!headerElement && <div>{headerElement}</div>}
          <h2>{title}</h2>
          {!!description && <div className="mb-3 description text-muted">{description}</div>}
        </div>
        <Button
          size="small"
          className="drawer-close-btn me-4"
          variant="contained"
          color="info"
          startIcon={<CloseIcon />}
          onClick={onClose}
          classes={{ startIcon: 'm-0' }}
        />
      </div>
      <div className={`h-100 ${overflow ? 'overflow-auto' : 'overflow-hidden'}`}>
        <div className="pe-4 h-100">{children}</div>
      </div>
    </MaterialDrawer>
  );
};
